import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "@environments/environment";
import { IAppConfig } from "./modelos/app-config.modelo";

@Injectable()
export class AppConfig {
  static settings: IAppConfig;
  constructor(private http: HttpClient) {}
  load(): Promise<void> {
    const jsonFile = environment.general.PRODUCTION
      ? "assets/config/config.json"
      : "assets/config/config.dev.json";

    return new Promise<void>((resolve) => {
      this.http
        .get(jsonFile)
        .toPromise()
        .then((response: IAppConfig) => {
          AppConfig.settings = response as IAppConfig;
          resolve();
        })
        .catch((error: any) => {
          console.error(`❌ Could not load config file '${jsonFile}':`, error);
          AppConfig.settings = {} as IAppConfig; // fallback vacío
          resolve(); // ✅ permite seguir cargando la app
        });
    });
  }
}
